var map = {
	"./img_categories/Fodder.jpg": 5428,
	"./img_categories/Fruit.jpg": 72,
	"./img_categories/Grain.jpg": 8419,
	"./img_categories/Grain.png": 8683,
	"./img_categories/Oil.jpg": 2810,
	"./img_categories/Oil.png": 5198,
	"./img_categories/Paddy.jpg": 6464,
	"./img_categories/Paddy.png": 916,
	"./img_categories/Pules.jpg": 4325,
	"./img_categories/Vegitable.jpg": 2891,
	"./img_categories/Wheat.jpg": 4111,
	"./img_categories/Wheat.png": 8159,
	"./img_categories/flowerblub.jpg": 4206,
	"./img_categories/flowerseed.jpg": 4630,
	"./img_categories/fodder.png": 1200,
	"./img_categories/fruitseed.jpg": 3599,
	"./img_categories/herbseed.jpg": 6221,
	"./img_categories/microgreenseed.jpg": 9706,
	"./img_categories/seedkit.jpg": 4575,
	"./img_categories/treeseed.jpg": 7507,
	"./img_categories/vegetableseed.jpg": 4076,
	"./img_products/basil_seed1.jpg": 8502,
	"./img_products/beetroot_seed1.jpg": 9949,
	"./img_products/beetroot_seed2.jpg": 50,
	"./img_products/beetroot_seed3.jpg": 2431,
	"./img_products/broccoli_seed1.jpg": 6248,
	"./img_products/broccoli_seed2.jpg": 4647,
	"./img_products/cherry_tomato_seed1.jpg": 5471,
	"./img_products/cherry_tomato_seed2.jpg": 8096,
	"./img_products/cherry_tomato_seed3.jpg": 2989,
	"./img_products/coriander_seed1.jpg": 9078,
	"./img_products/coriander_seed2.jpg": 497,
	"./img_products/coriander_seed3.jpg": 3124,
	"./img_products/fodder/bareem-goldwounder.jpeg": 1679,
	"./img_products/fodder/jai-kent.jpeg": 6779,
	"./img_products/fodder/jawar-harirani.jpeg": 852,
	"./img_products/fodder/makhhan-grass.jpeg": 6405,
	"./img_products/fodder/sudan-haramoti.jpeg": 7461,
	"./img_products/fodder/sudan-safedmoti.jpeg": 9532,
	"./img_products/fruit/cucumber.jpeg": 4338,
	"./img_products/fruit/papaya-honeyblue.jpeg": 5486,
	"./img_products/grain/bajra-multicut.jpeg": 4237,
	"./img_products/grain/jau-ratan393.jpeg": 147,
	"./img_products/grain/jau-ratna.jpeg": 260,
	"./img_products/grain/maize-shweta.jpeg": 1126,
	"./img_products/green_chilli_seed1.jpg": 1374,
	"./img_products/green_chilli_seed2.jpg": 8489,
	"./img_products/green_chilli_seed3.jpg": 7436,
	"./img_products/lotus_seed1.jpg": 6458,
	"./img_products/lotus_seed2.jpg": 37,
	"./img_products/lotus_seed3.jpg": 6072,
	"./img_products/oil/mustard-basanti.jpeg": 4077,
	"./img_products/oil/mustard-kalamoti.jpeg": 8501,
	"./img_products/oil/mustard-kalasona.jpeg": 4965,
	"./img_products/oil/mustard-patambari.jpeg": 352,
	"./img_products/oil/mustard-peelasona.jpeg": 1861,
	"./img_products/oil/mustard-t42.jpeg": 1485,
	"./img_products/oil/mustard-t59.jpeg": 7073,
	"./img_products/oil/til-n32.jpeg": 3879,
	"./img_products/oil/til-tarun.jpeg": 1912,
	"./img_products/oil/til-udai.jpeg": 8759,
	"./img_products/oil/toria-bhawani.jpeg": 6126,
	"./img_products/oil/toria-swati.jpeg": 572,
	"./img_products/oil/toria-t9.jpeg": 2645,
	"./img_products/paddy/peddy-sarbatiya.jpeg": 8455,
	"./img_products/papaya_seed1.jpg": 843,
	"./img_products/papaya_seed2.jpg": 6188,
	"./img_products/petunia_seed1.jpg": 7019,
	"./img_products/petunia_seed2.jpg": 1852,
	"./img_products/petunia_seed3.jpg": 6201,
	"./img_products/portulaca_seeds1.jpg": 3153,
	"./img_products/portulaca_seeds2.jpg": 5382,
	"./img_products/portulaca_seeds3.jpg": 6435,
	"./img_products/pules/arhar-bahar.jpeg": 9110,
	"./img_products/pules/arhar-kb17.jpeg": 4043,
	"./img_products/pules/arhar-mallika.jpeg": 8743,
	"./img_products/pules/arhar-nd1.jpeg": 7843,
	"./img_products/pules/arhar-nd2.jpeg": 5366,
	"./img_products/pules/arhar-pragati.jpeg": 824,
	"./img_products/pules/fieldpea-rachna.jpeg": 1527,
	"./img_products/pules/gram-pussa.jpeg": 2017,
	"./img_products/pules/masoor-PANT.jpeg": 176,
	"./img_products/pules/masoor-lintel-k75.jpg": 9828,
	"./img_products/pules/masoor-lintel-pl4.jpg": 7759,
	"./img_products/pules/moong-asc111.jpeg": 7924,
	"./img_products/pules/moong-samrat.jpeg": 1576,
	"./img_products/pules/moong-virat.jpeg": 6530,
	"./img_products/pules/urad-alnkar.jpeg": 1813,
	"./img_products/pules/urad-shekhar2.jpeg": 3724,
	"./img_products/pules/urad-shekhar3.jpeg": 6003,
	"./img_products/radish_seed1.jpg": 1294,
	"./img_products/radish_seed2.jpg": 7433,
	"./img_products/red_amaranthus_seed1.jpg": 7127,
	"./img_products/sage_seed1.jpg": 9801,
	"./img_products/spinach_seed1.jpg": 3415,
	"./img_products/spinach_seed2.jpg": 2488,
	"./img_products/spinach_seed3.jpg": 101,
	"./img_products/sunflower_seed1.jpg": 3376,
	"./img_products/sunflower_seed2.jpg": 6991,
	"./img_products/sunflower_seed3.jpg": 4610,
	"./img_products/thaibasil_seed1.jpg": 1336,
	"./img_products/tulsi_seed1.jpg": 2596,
	"./img_products/tulsi_seed2.jpg": 5171,
	"./img_products/vegitable/SOYA-GREENTOP.jpeg": 8918,
	"./img_products/vegitable/coriander-early30days.jpeg": 9186,
	"./img_products/vegitable/coriander-haritma.jpeg": 4753,
	"./img_products/vegitable/coriander-k21.jpeg": 1933,
	"./img_products/vegitable/coriander-kalmi.jpeg": 519,
	"./img_products/vegitable/coriander-saurabh.jpeg": 8105,
	"./img_products/vegitable/greenpea-ap3.jpeg": 717,
	"./img_products/vegitable/greenpea-as10.jpeg": 1532,
	"./img_products/vegitable/kulfa-greenlong.jpeg": 2970,
	"./img_products/vegitable/lobiya-haritma.jpeg": 4914,
	"./img_products/vegitable/methi-c9644.jpeg": 8477,
	"./img_products/vegitable/methi-k9644.jpeg": 1573,
	"./img_products/vegitable/methi-sugandh.jpeg": 7261,
	"./img_products/vegitable/onion-gwaran.jpg": 3290,
	"./img_products/vegitable/onion-lightred.jpeg": 5202,
	"./img_products/vegitable/palak-allgreen.jpeg": 9451,
	"./img_products/vegitable/palak-haldibari.jpeg": 5405,
	"./img_products/vegitable/palak-jobenargreen.jpeg": 6687,
	"./img_products/vegitable/palak-katedar.jpeg": 6973,
	"./img_products/vegitable/palak-pusajyoti.jpeg": 4559,
	"./img_products/vegitable/palak-pusavilayti.jpeg": 348,
	"./img_products/vegitable/peas-karishma.jpeg": 3813,
	"./img_products/vegitable/peas.jpeg": 4714,
	"./img_products/watermelon_seed1.jpg": 4075,
	"./img_products/watermelon_seed2.jpg": 6380,
	"./img_products/wheat/wheat-shekhar.jpeg": 399,
	"./img_products/wheat/wheat303.jpeg": 8184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8228;